import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Compare from "@/pages/Compare";
import Favourites from "@/pages/Favourites";
import AuthCallback from "@/pages/AuthCallback";
import AuthVerify from "@/pages/AuthVerify";
import GiftPage from "@/pages/GiftPage";
import CinemaMode from "@/pages/CinemaMode";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import HistoryPage from "@/pages/HistoryPage";
import TVGuidePage from "@/pages/TVGuidePage";
import TVAmbient from "@/pages/TVAmbient";
import TVCastReceiver from "@/pages/TVCastReceiver";
import ContactPage from "@/pages/ContactPage";
import AdminPremiumAudit from "@/pages/AdminPremiumAudit";
import InstallPWA from "@/components/InstallPWA";
import SignInModal from "@/components/SignInModal";
import AnalyticsBoot from "@/lib/analytics-boot";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { EntitlementProvider } from "@/context/EntitlementContext";

/**
 * Detect the OAuth callback synchronously during render so we always
 * process the session_id BEFORE any other route mounts.
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/compare" element={<Compare />} />
      <Route path="/snapshot" element={<Dashboard />} />
      <Route path="/snapshot/:id" element={<Dashboard />} />
      <Route path="/favourites" element={<Favourites />} />
      <Route path="/watch/:id" element={<CinemaMode />} />
      <Route path="/history/:slug" element={<HistoryPage />} />
      <Route path="/tv" element={<TVGuidePage />} />
      <Route path="/tv/ambient" element={<TVAmbient />} />
      <Route path="/tv/cast" element={<TVCastReceiver />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/auth/verify" element={<AuthVerify />} />
      <Route path="/gift/:code" element={<GiftPage />} />
      <Route path="/admin/premium-audit" element={<AdminPremiumAudit />} />
    </Routes>
  );
}

function GlobalSignInHost() {
  const { signInOpen, hideSignIn, signInReturnPath } = useAuth();
  return <SignInModal open={signInOpen} onClose={hideSignIn} returnPath={signInReturnPath} />;
}

function App() {
  return (
    <div className="App paper-grain">
      <BrowserRouter>
        <AuthProvider>
          <EntitlementProvider>
            <AnalyticsBoot />
            <AppRouter />
            <GlobalSignInHost />
            <InstallPWA />
          </EntitlementProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FAF7F2",
            color: "#1A1C20",
            border: "2px solid #1A1C20",
            borderRadius: 0,
            fontFamily: "Special Elite, monospace",
            boxShadow: "4px 4px 0 #1A1C20",
          },
        }}
      />
    </div>
  );
}

export default App;
